<template>
    <BCol :md="props.cols" class="mb-3">
        <label :class="`form-label${isRequired() ? ' form-label-required' : ''}`">{{ props.label }}</label>

        <BFormRadioGroup
            v-model="value"
            :options="options"
            :state="v == null ? null : v.$errors.length == 0"
            :disabled="$attrs.disabled"
        />

        <BFormInvalidFeedback v-for="(error, index) of errors()" :key="`error${index}`">{{ error.$message }}</BFormInvalidFeedback>
    </BCol>
</template>

<script setup>
    import { defineProps, defineEmits, computed } from 'vue';
    
    const emit = defineEmits(['update:modelValue', 'change'])
    const props = defineProps({
        modelValue: {  },
        options: { type: Array, required: true, default: new Array() },
        required: { type: Boolean, default: false },
        label: { type: String, required: true },
        cols: { required: true },        
        v: { type: Object, required: false, default: null }
    })
    const errors = () => {
        if (props.v == null) {
            return []
        }
        return props.v.$errors
    }
    const value = computed({
        get: () => {
            return props.modelValue
        },
        set: (v) => {
            emit('change', v)
            emit('update:modelValue', v)
        }
    })

    const isRequired = () => {
        return props.required === true || (
            props.v && (props.v.required || props.v.requiredIf)
        )
    }

</script>